import { Applicant, APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'

export interface applicantsList {
  last_name?: string
  first_name?: string
  id: string
  lead: boolean
  active: boolean
  kind: APPLICANT_KIND
  relatedApplicant?: applicantsList
}

const findRelatedApplicant = (applicants: Applicant[], id?: string): applicantsList | undefined => {
  if (id) {
    const related = applicants.find((applicant) => applicant.id === id)
    if (related) {
      return {
        last_name: related.last_name,
        first_name: related.first_name,
        id: related.id,
        lead: related.kind === APPLICANT_KIND.main,
        kind: related.kind,
        active: false,
      }
    }
  }
  return undefined
}
/**
 * @description Return a list of applicants with last name, first name, reference, if none or 1 applicant is found then return false
 * @requires {string} application
 * @params {string | undefined} userReference
 * @returns false | applicantsList[
 */
export const getApplicantsListOrUndefined = (
  applicants: Applicant[] | undefined,
  currentUserId?: string
): undefined | applicantsList[] => {
  if (applicants) {
    if (applicants.length > 1) {
      const array: applicantsList[] = []
      applicants.forEach((element) => {
        array.push({
          last_name: element.last_name,
          first_name: element.first_name,
          id: element.id,
          lead: element.kind === APPLICANT_KIND.main,
          kind: element.kind,
          active: currentUserId ? currentUserId === element.id : false,
          relatedApplicant: findRelatedApplicant(applicants, element.applicant_id),
        })
      })

      return array
    }
  }

  return undefined
}
